// extracted by mini-css-extract-plugin
export default {"leftNav":"gallery-overlay_leftNav__p+Jox","rightNav":"gallery-overlay_rightNav__GepDp","overlay":"gallery-overlay_overlay__F8ycu"};